import React, { ClipboardEvent } from "react";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableBody from "@mui/material/TableBody";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { HorizontalHeaders } from "./utils/header.utils";
import { StyledTableCell } from "../../../components/ShipmentSummary/components/SummaryGrid/SummaryGrid";
import {
  BACKGROUND_GRAY,
  GREEN_05,
  LIGHT_BACKGROUND_GRAY,
  TABLE_BORDER_GRAY,
} from "../../../constants/css.constants";
import ClickableCell from "../../../components/ClickableCell/ClickableCell";
import Typography from "@mui/material/Typography";
import { formatNumbersWithCommas } from "../../../constants/utils";
import Table from '@mui/material/Table';

const defaultColSpan = 3;
type ForecastTableProps = {
  data: Array<Array<number>>;
  horizontalHeaders: HorizontalHeaders;
  updateData: (row: number, column: number) => (units: string) => void;
  tab: string;
  monthsInFirstTwoSeasons: number;
  onPaste: (row: number, column: number) => (e: ClipboardEvent) => void;
  additionalHeaders: string[];
  setNextCell: (row: number, column: number) => () => void;
  selectedCell: { row: number; column: number };
};
const FuturesTable = ({
  data,
  horizontalHeaders,
  tab,
  monthsInFirstTwoSeasons,
  onPaste,
  additionalHeaders,
  updateData,
  selectedCell,
  setNextCell,
}: ForecastTableProps) => {
  const isTB = tab.toLowerCase() === "tb";

  return (
    <TableContainer component={Paper}>
      <Table size="small">
      <TableHead>
        <TableRow>
          <StyledTableCell
            rowSpan={4}
            colSpan={defaultColSpan}
            cssProperties={{
              borderTop: TABLE_BORDER_GRAY,
              borderLeft: TABLE_BORDER_GRAY,
              fontSize: "24px",
            }}
            padding='none'
            size='small'
          >
            <Typography variant="h6">{tab}</Typography>
          </StyledTableCell>
        </TableRow>
        <TableRow>
          {horizontalHeaders.SEASONS.map((season) => (
            <StyledTableCell
              key={season.value}
              colSpan={season.colSpan}
              cssProperties={{
                borderTop: TABLE_BORDER_GRAY,
                minWidth: `${season.colSpan * 100}px`,
              }}
              padding='none'
              size='small'
            >
              {season.value}
            </StyledTableCell>
          ))}
          <StyledTableCell
            rowSpan={2}
            cssProperties={{
              borderTop: TABLE_BORDER_GRAY,
              borderLeft: TABLE_BORDER_GRAY,
              backgroundColor: "#FFF",
              color: "black",
              fontSize: "24px",
            }}
            padding='none'
            size='small'
          ></StyledTableCell>
        </TableRow>
        <TableRow>
          {horizontalHeaders.QUARTERS.map((season, i) => (
            <StyledTableCell
              key={season.value + i}
              colSpan={season.colSpan}
              cssProperties={{
                borderTop: TABLE_BORDER_GRAY,
                width: `${season.colSpan * 100}px`,
              }}
              padding='none'
              size='small'
            >
              {season.value}
            </StyledTableCell>
          ))}
        </TableRow>
        <TableRow>
          {horizontalHeaders.MONTHS.map((season) => (
            <StyledTableCell key={season} cssProperties={{ width: "100px" }}
                             padding='none'
                             size='small'>
              {season}
            </StyledTableCell>
          ))}
          {additionalHeaders.map((season) => (
            <StyledTableCell
              key={season}
              cssProperties={{
                whiteSpace: "nowrap",
              }}
              padding='none'
              size='small'
            >
              {season}
            </StyledTableCell>
          ))}
        </TableRow>
      </TableHead>
      <TableBody>
        <TableRow>
          <StyledTableCell
            cssProperties={{
              minWidth: "200px",
              borderLeft: TABLE_BORDER_GRAY,
              whiteSpace: "nowrap",
            }}
            colSpan={3}
            padding='none'
            size='small'
          >
            Futures Total
          </StyledTableCell>
          {data[0].map((total, column) => {
            const isShortRange = column < monthsInFirstTwoSeasons;
            return (
              <ClickableCell
                disabled={isTB}
                updateData={updateData(0, column)}
                type="number"
                key={`${column}-${column * 31 + 1}`}
                styles={
                  isTB && isShortRange
                    ? {
                        backgroundColor: LIGHT_BACKGROUND_GRAY,
                        color: "black",
                      }
                    : isTB
                      ? {
                          backgroundColor: BACKGROUND_GRAY,
                          color: "#FFF",
                        }
                      : isShortRange
                        ? {
                            backgroundColor: GREEN_05,
                            color: "#000",
                          }
                        : {
                            backgroundColor: "white",
                            color: "#000",
                          }
                }
                onPaste={onPaste(0, column)}
                transform={formatNumbersWithCommas}
                value={total}
                isSelected={selectedCell.column === column}
                setNextCell={setNextCell(0, column)}
              />
            );
          })}
        </TableRow>
      </TableBody>
            </Table>
    </TableContainer>
  );
};

export default FuturesTable;
